import type { DragEvent } from 'react'

import { pageImageCommitDotClass } from '../../lib/comicPageImageStatus'
import { chromeToggleChipClass } from '../ChromeSurface'
import { ChromeTooltip } from '../ChromeTooltip'
import { type ComicSaveStatus,ComicSaveStatusDot } from './ComicSaveStatusPill'

type Props = {
  angular: boolean
  active: boolean
  title: string
  meta?: string
  statusDot?: ComicSaveStatus
  /** 整页成图是否已定稿：主题色点 / 灰色点（与标题同一行） */
  pageImageCommitted?: boolean
  onClick: () => void
  role?: 'tab' | 'button'
  'aria-selected'?: boolean
  dropHighlight?: boolean
  onDragOver?: (e: DragEvent<HTMLButtonElement>) => void
  onDragLeave?: (e: DragEvent<HTMLButtonElement>) => void
  onDrop?: (e: DragEvent<HTMLButtonElement>) => void
}

/** 话次/分页芯片：选中态下附属文案与主文案同色阶，避免灰字叠在蓝底上发虚、抖动 */
export function ComicRailChip({
  angular,
  active,
  title,
  meta,
  statusDot,
  pageImageCommitted,
  onClick,
  role = 'button',
  'aria-selected': ariaSelected,
  dropHighlight = false,
  onDragOver,
  onDragLeave,
  onDrop,
}: Props) {
  return (
    <button
      type="button"
      role={role}
      aria-selected={ariaSelected}
      onClick={onClick}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      className={[
        chromeToggleChipClass(angular, active),
        'min-h-[2.25rem] flex-none',
        dropHighlight ? 'ring-2 ring-inset ring-accent' : '',
      ].join(' ')}
    >
      <span className="inline-flex max-w-full items-center gap-1.5 tabular-nums leading-none">
        {statusDot ? <ComicSaveStatusDot status={statusDot} angular={angular} onAccentBg={active} /> : null}
        {pageImageCommitted !== undefined ? (
          <ChromeTooltip
            content={pageImageCommitted ? '本页已定稿' : '本页未定稿'}
            angular={angular}
            side="top"
            align="center"
          >
            <span
              className={[
                'h-2 w-2 shrink-0 ring-inset',
                pageImageCommitDotClass(pageImageCommitted, active, angular),
              ].join(' ')}
              aria-label={pageImageCommitted ? '本页已定稿' : '本页未定稿'}
            />
          </ChromeTooltip>
        ) : null}
        <span className="whitespace-nowrap">{title}</span>
        {meta ? (
          <span
            className={[
              'whitespace-nowrap text-xs font-semibold',
              active ? 'text-white/80' : 'text-ink-soft',
            ].join(' ')}
          >
            {meta}
          </span>
        ) : null}
      </span>
    </button>
  )
}
